import React from 'react';
import { Layout } from '@components/Layout';
import PermissionGate from '@components/upercut-permissions/PermissionGate';
import JobApplicationsModule from '@modules/jobApplications/JobApplicationsPage';
import JobApplicationDetailModule from '@modules/jobApplications/JobApplicationDetail';
import { Route, Routes } from 'react-router-dom';

const JobApplicationsPage = () => {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <Layout
                        breadcrumbs={[
                            { label: 'Dashboard', href: '/', value: 'dashboard' },
                            { label: 'Candidatures', href: '/applications', value: 'applications' },
                        ]}
                        heading="Candidatures"
                    >
                        <PermissionGate permission="job-applications:read">
                            <JobApplicationsModule />
                        </PermissionGate>
                    </Layout>
                }
            />
            <Route
                path="/:id/details"
                element={
                    <PermissionGate permission="job-applications:read">
                        <JobApplicationDetailModule />
                    </PermissionGate>
                }
            />
        </Routes>
    );
};

export default JobApplicationsPage;
